export default "__VITE_ASSET__BZYavubr__"